import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {
  AppLanguage,
  LANGUAGE_OPTIONS,
  useLanguage,
} from '../i18n/LocalizationContext';

interface LanguagePreferenceSelectProps {
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  minWidth?: number;
}

const LanguagePreferenceSelect: React.FC<LanguagePreferenceSelectProps> = ({
  fullWidth = true,
  size = 'small',
  minWidth = 180,
}) => {
  const selectId = React.useId();
  const { language, setLanguage, t, getLanguageName } = useLanguage();
  const label = t('language.preferred');

  const handleChange = (event: SelectChangeEvent) => {
    setLanguage(event.target.value as AppLanguage);
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={{ minWidth: fullWidth ? undefined : minWidth }}>
      <InputLabel id={`${selectId}-label`}>{label}</InputLabel>
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        value={language}
        label={label}
        onChange={handleChange}
      >
        {LANGUAGE_OPTIONS.map((option) => (
          <MenuItem key={option.code} value={option.code}>
            {getLanguageName(option.code)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguagePreferenceSelect;
